import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import {} from 'react-hot-toast'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <ToastProvider> */}

    <App />
    {/* </ToastProvider> */}
  </React.StrictMode>
);

